import { useCrmSession } from "../../../context/CrmSessionContext";

/**
 * Enlace discreto a la ficha del lead en el CRM, entre los paneles de Tickets y
 * Actividad del aside. Abre `${REACT_APP_CRM_APP_URL}/leads/:leadUlid` en una
 * pestaña nueva. La ruta de la ficha del CRM es `/leads/:leadId` (crm/apps/web
 * App.tsx). `leadUlid` llega ya RESUELTO a la ficha canónica del CRM
 * (CrmLeadPanels + crmLeadResolve): normalmente es el mismo ULID que
 * Operations, pero en un lead re-registrado es el de la ficha superviviente.
 *
 * `redirected` marca el caso en que el id difiere del de la ruta de Operations
 * (lead re-registrado o fusionado): se avisa en una línea discreta para que
 * Operaciones entienda por qué el CRM abre otra ficha.
 *
 * `connectUrl` es la base del CRM (REACT_APP_CRM_APP_URL sin barra final), la
 * misma que CrmSessionContext usa para el botón "Conectar con CRM".
 */
export default function CrmLeadLink({
  leadUlid,
  redirected = false,
}: {
  leadUlid: string;
  redirected?: boolean;
}) {
  const { connectUrl } = useCrmSession();
  const href = `${connectUrl}/leads/${encodeURIComponent(leadUlid)}`;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        margin: "-0.35rem 0 0.75rem",
      }}
    >
      {redirected && (
        <span
          style={{
            fontSize: ".7rem",
            color: "#b0821f",
            marginBottom: "0.15rem",
          }}
        >
          La ficha del CRM vive bajo otro id (lead re-registrado o fusionado)
        </span>
      )}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          fontSize: ".76rem",
          color: "#73879C",
          textDecoration: "none",
          fontWeight: 600,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = "#0069d9";
          e.currentTarget.style.textDecoration = "underline";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "#73879C";
          e.currentTarget.style.textDecoration = "none";
        }}
      >
        Ver lead en el CRM ↗
      </a>
    </div>
  );
}
